var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_187_3047",
    transform: "scale(0.0208333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_187_3047",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAJSSURBVHgB7ZlNTuMwFMdf0lm0XfUIucHAotIshxNMbzDiBDMsWnWHu+rHhnACYMmunACW3ZEb0CN01Q9Vbfk/KUKOcQkkcR3APymKY78o/sf288cjcji+N16aQbfb/b3b7f4g2cI9oMMQeZ7HV28wGEzfMtwrQAjRmM/n50j+J4tARFir1Xqoz0xbrsuMK3+P5BGVg6her5/oRPg66/jPl6XyzNFisTjXFbxqAfT5YLvdPiWMPG+K67RarUb7mrJIOp1OC9+7UMec7/snGBMPiTz1ZbyUUMqVRx885hcPUXlmNBqNV6vVMX+bknVrqbY6AYmuA9Vnh6q4TBiGM251OS/2hgl0YyAhoN/vj8kSy+UyUrIC1canEsOtkGZTagHv4QcZAp7kL24hrlmlUhHoijdkAJMtIHA1cAWbzSYkQ5gUEEjpBhni048BJ8A2ToBtMs8Dkp9/l4eB/W5P0TTPPJGnBQQV4x5zzRN5BBTm27HqzLzazSyAl9nqej0jM2ygepSRzGMAG5xr3K73lat9HpuU1BOQLDg3ahsnwDZOwBu8+PaC3K0WYwKkeSKXn0/D2J44bZ4oiq8/BvikmkqMTsBUfsDpmLVTaj7klZ856KHa6M5G7+RnDMArG60Qf/NCyU4XgM2FehYaIF7wqP4NU3DFOazF3yTlLJRDTqq9doXYbrdDGP+jEoH6XA6Hw1fhLu0gXq/XgjTNZZEIMQqhK6joMieTybLZbN5iMqpB+S+yCP95xMdOPxTkk4lDTgLJn3SguFk8g9/hPlZDSg6HI8kzukbOk/C/Z2cAAAAASUVORK5CYII="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon-edit.c2b6414c403f2aac1be04553c932ab76.svg";
export { ForwardRef as ReactComponent };